import { render, staticRenderFns } from "./IconSelectorView.vue?vue&type=template&id=2dad57ed"
import script from "./IconSelectorView.vue?vue&type=script&lang=js"
export * from "./IconSelectorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports